<template>
    <div class="index">
        <div class="banner">
            <!-- <a href="http://assistant.yousi.com/"  target="view_windo"> -->
                <div class="img-banner">
                    <img :src="Ren" class="ren-gif" alt="大学生网上兼职">
                    <img :src="YunOne" alt="大学生网上兼职" class="yun-one"> 
                    <img :src="YunTwo" alt="大学生网上兼职" class="yun-two">    
                    <button @click="btn">加入我们</button>
                </div> 
            <!-- </a> -->
        </div>
        <div class="box">
            <div class="assistant">
                <div class="assistant_top">
                    <div class="assistant_left">
                        <span></span>
                        <h1>
                            关于托乐乐·云端助教
                        </h1>
                        <span>
                            托乐乐·云端助教隶属于上海优思教育集团<br>
                            国内首家专注于晚托班，结合人工智能&线下高端晚托班店铺，为小学学生及家长提供优质服务！
                        </span>
                    </div>
                    <div class="assistant_right">
                        <img :src="Assistant" class="img_assistant" alt="大学生网上兼职">
                    </div>
                </div>
                <ul class="assistant_bottom">
                    <li>
                        <p>
                            <span class="num">{{count}}</span><span>+助教</span>
                        </p>
                        <p>在线服务</p>
                    </li>
                    <li>
                        <p>
                            <span class="num">{{counts}}</span><span>+学员</span>
                        </p>
                        <p>累计服务</p>
                    </li>
                    <li>
                        <p>
                            <span class="num">{{nums}}</span><span>+作业</span>
                        </p>
                        <p>完成批改</p>
                    </li>
                </ul>
            </div>
            <div class="know">
                <div class="know_top">
                    <span></span>
                    <span>认识我们</span>
                </div>
                <div class="know_bottom">
                    <ul class="know_left">
                        <li>
                            <span>托乐乐是什么？</span>
                            <p>
                                托乐乐即上海剑优教育科技有限公司独家自研的管理系统。<br>
                                托乐乐隶属于上海优思教育集团，国内首家专注于晚托班，结合人工智能&线下高端晚托班店铺，为小学学生及家长提供优质服务！
                            </p>
                        </li>
                        <li>
                            <span>云端助教是什么？</span>
                            <p>"云端助教主要由在校大学生和在职教师组成，以兼职的形式受聘于托乐乐。利用课余空闲时间，在线进行兼职任务"</p>
                        </li>
                        <li>
                            <span>云端助教要做什么？</span>
                            <p>"每日会由晚托班班主任，将该日学员的作业进行上传。
云端助教则负责对应作业单的录入、作业的批改、批改产生错题的录入"</p>
                        </li>
                    </ul>
                    <div class="know_right">
                        <img :src="Know" class="img_know" alt="大学生网上兼职">
                    </div>
                </div>
            </div>
            <div class="become">
                <div class="know_top">
                    <span></span>
                    <h1>如何成为云端助教？</h1>
                </div>     
                <div class="become_bottom">
                    <dl>
                        <dt>
                            <img :src="Audit" alt="大学生网上兼职" class="img_audit">
                        </dt>
                        <dd>
                            <span>注册账号</span>
                            <p>进入注册页面，免费注册账号。根据要求提示填写信息。</p>
                        </dd>
                    </dl>
                    <dl>
                        <dt>
                            <img :src="Appraisal" alt="大学生网上兼职" class="img_appraisal">
                        </dt>
                        <dd>
                            <span>学习&能力测评</span>
                            <p>选择学科进行能力测试、操作流程学习&操作流程测试等步骤。</p>
                        </dd>
                    </dl>
                    <dl>
                        <dt>
                            <img :src="Audit" alt="大学生网上兼职" class="img_audit">
                        </dt>
                        <dd>
                            <span>资质审核</span>
                            <p>提交资质凭证等信息后，等待审核审核通过后，即可收到通知成为云端助教</p>
                        </dd>
                    </dl>
                </div>
            </div>
        </div>
        <Suspend :btnFlag="btnFlag"></Suspend>
        <!-- <el-carousel :interval="4000" type="card" height="200px">
            <el-carousel-item v-for="item in 6" :key="item">
                <h3 class="medium">{{ item }}</h3>
            </el-carousel-item>
        </el-carousel> -->
    </div>
</template>

<script>
import Assistant from '../../assets/img/assistant.png'
import Know from '../../assets/img/know.png'
import Audit from '../../assets/img/audit.png'
import Appraisal from '../../assets/img/appraisal.png'
import Ren from '../../assets/img/ren.gif'
import YunOne from '../../assets/img/yun-one.png'
import YunTwo from '../../assets/img/yun-two.png'
import Suspend from '../suspend/suspend'

export default {
    components: {
        Suspend
    },
    metaInfo: {
        title: '托乐乐-云端助教-安全可靠的大学生网络兼职',
        meta: [
            { name: 'Keywords', content: '兼职；赚钱；大学生；在线；家教；批改；作业；助教；实习；找工作' },
            { name: 'description', content: '托乐乐-云端助教是由上海优思教育集团，为大学生和在职老师提供的，安全可靠的网上兼职平台。仅需在线注册，即可开始兼职，为学生检查作业，整理错题，获得兼职受益。' }
        ]
    },
    data () {
        return {
            Assistant,
            Know,
            Audit,
            Appraisal,
            Ren,
            YunOne,
            YunTwo,
            count: 2000,
            counts: 40000,
            nums: 150000,
            btnFlag: '',
            flag: true,
            str:'https://assistant.tuolele.cn/index.html'
        }
    },
    mounted() {
        window.addEventListener('scroll', this.scrollToTop, true)
    },
    methods: {
        btn() {
            // window.location.href = 'http://assistant.yousi.com/';
            // let details = this.$router.resolve({
            //     name: "details",
            //     query: params,
            //     params:{catId:params.catId}
            // });
            // window.open(details.href, "_blank")
            window.open(this.str)
        },
        scrollToTop () {  
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop > 2460) {
                this.btnFlag = 'actives'
            } else {
                this.btnFlag = ''
            }

            if(scrollTop>700 && this.flag) {
                this.count = 0;
                this.counts = 0;
                this.nums = 0;
                let that = this;
                let t = setInterval( function(){
                    var number = 100;
                    if(that.count < 2000) {
                        that.count += 20
                    }
                    if (that.counts < 40000) {
                        that.counts += 200
                    }
                    if (that.nums < 150000) {
                        that.nums += 1500
                    }
                }, 10 )

                this.flag = false;
            }
        }   
    }
}
</script>

<style scoped lang='scss'>
.index {
    width: 100%;
    min-width: 1100px;
    position: relative;
    .banner {
        width: 100%;
        .img-banner {
            width: 100%;
            height: 750px;
            background-repeat:no-repeat;
            background-image: url(http://late-care.tuolele.cn/banner.a63b72c.jpg);
            position: relative;
            button {
                width: 240px;
                height: 58px;
                background-color:#fff;
                color: #2e92f0;
                font-size: 26px;
                border-radius: 6px;
                border: 0;
                position: absolute;
                left: 1300px;
                top: 450px;
                font-weight:bold;
                cursor: pointer;
            }
            .ren-gif {
                width: 160px;
                height: 172px;
                position: absolute;
                top: 184px;
                left: 300px;
            }

            @keyframes dong {
                0% {
                    transform: translate(0px, 0px);
                }
                50% {
                    transform: translate(0px, -50px);
                }
                100% {
                    transform: translate(0px, 0px);
                }
            }

            @keyframes dong1 {
                0% {
                    transform: translate(0px, 0px);
                }
                50% {
                    transform: translate(0px, 50px);
                }
                100% {
                    transform: translate(0px, 0px);
                }
            }

            .yun-one {
                width: 90px;
                height: 90px;
                position: absolute;
                top: 130px;
                left: 150px;
                animation: dong 3.5s infinite;
            }
            .yun-two {
                width: 115px;
                height: 115px;
                position: absolute;
                top: 110px;
                left: 840px;
                animation: dong1 3.5s infinite;
            }
        }
    }
    .box {
        max-width: 1100px;
        height: 100%;
        margin: 0 auto; 
        margin-bottom: 205px;
        .know_top {
            width: 100%;
            height: 100%;
            text-align: center;
            h1 {
                font-size: 40px;
                color: #43557a;
                font-weight: normal;
            }   
            span {
                &:first-child {
                    width: 19px;
                    height: 6px;
                    background-color: #43557b;
                    border-radius: 3px;
                    display: block;
                    margin: 25px auto;
                }
                &:last-child {
                    font-size: 40px;
                    color: #43557a;
                }
            }
        }
        .assistant {
            width: 100%;
            .assistant_top {
                width: 100%;
                height: 346px;
                margin-top: 114px;
                .assistant_left {
                    width: 444px;
                    h1 {
                        width: 304px;
                        height: 31px;
                        font-size: 32px;
                        color: #32b3fd;
                        margin: 24px 0 34px 0;
                        display: block;
                        font-weight: normal;
                    }
                    span {
                        &:nth-child(1) {
                            width: 18px;
                            height: 6px;
                            background-color: #32b3fd;
                            border-radius: 3px;
                            display: block;
                            margin-top: 75px;
                        }
                        &:nth-child(3) {
                            width: 444px;
                            height: 86px;
                            display: block;
                            width: 444px;
                            font-size: 16px;
                            color: #98a4b9;
                            line-height: 35px;
                        }
                    }
                }
                .assistant_right {
                    margin-left: 87px;
                    .img_assistant {
                        width: 509px;
                        height: 342px;
                    }
                }
                .assistant_left,
                .assistant_right {
                    float: left;
                }
            }
            .assistant_bottom {
                width: 1100px;
                height: 220px;
                background-color: #ffffff;
                border-radius: 10px;
                border: solid 6px #f2f6fd;
                margin: 102px 0 111px 0;
                padding: 0 50px;
                li {
                    width: 33.33%;
                    float: left;
                    text-align: center;
                    p {
                        &:first-child {
                            font-size: 40px;
                            color: #31b3fd;
                            margin: 50px 0 15px 0;
                            font-weight:bold;

                        }
                        &:last-child {
                            font-size: 20px;
                            color: #71819f;
                        }
                    }
                }
            }
        }
         .know {
            width: 100%;
            .know_bottom{
                width: 100%;
                height: 695px;
                .know_left {
                    width: 494px;
                    height: 676px;
                    float: left;
                    li {
                        &:first-child {
                            padding-top: 100px;
                        }
                        &:nth-child(2) {
                            margin: 28px 0 35px 0;
                        }
                        &:nth-child(3) {
                            width:460px;
                        }
                        span {
                            color: #32b3fd;
                            font-size: 28px;
                        }
                        p {
                            color: #98a4b9;
                            font-size: 15px;
                            margin-top: 15px;
                            line-height: 33px;
                        }
                    }
                }
                 .know_right {
                    float: right;
                    .img_know {
                        width: 601px;
                        height: 515px;
                        margin-top: 89px;
                    }
                }
            }
        }  
        .become {
            width: 100%;
            padding-top: 85px;
            .become_bottom {
                width: 100%;
                height: 420px;
                margin-top: 97px;
                dl {
                    width: 33.33%;
                    height: 100%;
                    float: left;
                    dt {
                        width: 292px;
                        height: 202px;
                        position: relative;
                        .img_audit {
                            width: 292px;
                            height: 202px;
                        }

                        .img_appraisal {
                            width: 292px;
                        }
                        img {
                            position: absolute;
                            bottom: 0;
                        }
                    }
                    dd {
                        width: 255px;
                        height: 100%;
                        text-align: center;
                        padding-top: 58px;
                        margin-left: 20px;
                        span {
                            font-size: 28px;
                            color: #32b3fd;
                        }
                        p {
                            font-size: 15px;
                            color: #98a4b9;
                            line-height: 34px;
                            margin-top: 11px;
                        }
                    }
                }
            }
        }
    }
}

/* .become_bottom>dl:nth-child(1) {
    padding-right: 102px;
}*/



/* 旋转木马轮播 */
/* .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
} */
</style>



// WEBPACK FOOTER //
// src/components/section/index.vue